import React, { useEffect, useState, useRef } from "react";
import PageHeader from "../../components/PageHeader.js";
import { Toast } from "react-bootstrap";
import {getLastSession,getLastUser,getDashboardInfo,getCurrentDeviceSerial,setCurrentDeviceSerial, setUserInfo} from '../../Data/SessionData.js';
import { createSession, loginUser, dashboardData, updateAddlSerials, resetDevice, getMyProfile } from '../../RestUtil.js';

export default function MyProfile() {

  const [profileData, setProfileData] = useState(null);    
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [email, setEmail] = useState(""); 
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [deviceSerial, setDeviceSerial] = useState("");
  const [dashData1, setDashData1] = useState(null);    
  const [currDeviceSerial, setCurrDeviceSerial] = useState(getCurrentDeviceSerial);
  const [addlSerials, setAddlSerials] = useState([]);    
  const [origSerials, setOrigSerials] = useState([]);    
  const [showToast, setShowToast] = useState(false);    
  const [toastMessage, setToastMessage] = useState("");    

  useEffect(() => {
    var profileData = getLastUser();
    console.log("BE Data from ProfileV1Setting", profileData);
    setProfileData( profileData );
    setFirstName(profileData.firstName===null?"":profileData.firstName);
    setLastName(profileData.lastName===null?"":profileData.lastName);
    setEmail(profileData.emailAddress);
    setMobileNumber(profileData.mobileNumber===null?"":profileData.mobileNumber);
    setDeviceSerial(profileData.deviceSerial);
    if (profileData.addlDeviceSerials && profileData.addlDeviceSerials.length > 0) {
       setAddlSerials(profileData.addlDeviceSerials);
       setOrigSerials(profileData.addlDeviceSerials);
    }
    else {
       setAddlSerials([]);
       setOrigSerials([]);
    }
    var dashData2 = getDashboardInfo();
    console.log("BE Data from MyProfile", dashData2);
    setDashData1( dashData2 );
    if (profileData.userType === 'admin') {
       document.getElementById("btnAddNew").disabled = true;
       document.getElementById("btnUpdate").disabled = true;
    }
  }, []);

  useEffect(() => {
    console.log("AddlSerials len = ",addlSerials.length);
  }, [addlSerials]);

  const refreshMyProfile = () => {
    var profileData = getLastUser();
    var sessionData = getLastSession();
    getMyProfile(sessionData.id, profileData.id).then(resp => {
      console.log("getMyProfile success",resp);
      console.log("getMyProfile addlDevices",resp.addlDeviceSerials);
      setUserInfo(resp);
      setAddlSerials(resp.addlDeviceSerials);
      setOrigSerials(resp.addlDeviceSerials);
   })
    .catch(err => {
      console.log("getMyProfile Failed",err);        
    }); 
  }

  const deviceSerialChanged = (newSerial) => {
    console.log("Device Serial changed detected3 in Dashboard",newSerial);
    setCurrentDeviceSerial(newSerial);
    setCurrDeviceSerial(newSerial);
  }

  const toggleShow = () => {
    setShowToast(false);
  }

  const saveAddlSerials = () => {
    console.log("Now invoking updateAddlSerials for userId",profileData.id);
    var sessionData = getLastSession();
    updateAddlSerials(sessionData.id,profileData.id, addlSerials).then(resp => {
      console.log("saveAddlSerials resp",resp);
      setOrigSerials(addlSerials);
      refreshMyProfile();
      setToastMessage("Device Serial Update success");
      setShowToast(true);
    })
    .catch(err2 => {
      setToastMessage(err2.response.data);
      setShowToast(true);
      console.log("saveAddlSerials failed",err2.response.data);          
    });
  }

    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
          <Toast style={{float:"right"}} show={showToast} onClose={toggleShow} delay={3000} autohide>
            <Toast.Header>
                <strong className="me-auto">Update Response</strong>
                <small>Just now</small>
            </Toast.Header>
            <Toast.Body style={{color:"red", backgroundColor:"white"}}>{toastMessage}</Toast.Body>
          </Toast>
          {dashData1 && 
            <PageHeader
              HeaderText="My Profile"
              Breadcrumb={[
                { name: "Home", navigate: "" },
                { name: "My Profile", navigate: "" },
              ]}
              LastUpdatedDate={dashData1.lastUpdatedDateTime} 
              deviceSerial={currDeviceSerial}
              callback={deviceSerialChanged}
            />
          }
        <div>
        <form className="form-auth-small ng-untouched ng-pristine ng-valid">
        <div className="body">
          <h6>Basic Information</h6>
          <div className="row clearfix">
            <div className="col-lg-6 col-md-12">
              <div className="form-group">
                <input className="form-control" placeholder="First Name" type="text" value={firstName}
                  onChange={val => {
                    setFirstName(val.target.value);
                  }} />
              </div>
              <div className="form-group">
                <input className="form-control" placeholder="Last Name" type="text" value={lastName}
                  onChange={val => {
                    setLastName(val.target.value);
                  }} />
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="form-group">
                <input className="form-control" placeholder="Email Address" type="text" value={email}
                  onChange={val => {
                    setEmail(val.target.value);
                  }} />
              </div>
              <div className="form-group">
                <input className="form-control" placeholder="Mobile Number" type="text" value={mobileNumber}
                  onChange={val => {
                    setMobileNumber(val.target.value);
                  }} />
              </div>
            </div>
          </div>
          <button className="btn btn-primary" type="button">
            Update
          </button>{" "}
          &nbsp;&nbsp;
          <button className="btn btn-default" type="button">
            Cancel
          </button>
        </div>
        <div className="body">
          <div className="row clearfix">
            <div className="col-lg-6 col-md-12" style={{paddingTop:"10px"}}>
              <h6>Device Serial</h6>
              <div className="form-group" id="devSer1">
                <input className="form-control" placeholder="Device Serial" type="text" value={deviceSerial} readOnly/>
              </div>
              {addlSerials.length > 0 && addlSerials.map((addlSerial, index) => {
                  return (
                    <div className="form-group" key={index}>
                      {(origSerials.includes(addlSerial))?
                      <input className="form-control" placeholder="Device Serial" type="text" value={addlSerial} readOnly/>
                      :
                      <input className="form-control" placeholder="Device Serial" type="text" value={addlSerial}
                      onChange={(event) => {
                        let newVal = event.target.value;
                        if (addlSerials.includes(newVal) || newVal === deviceSerial) {
                           event.target.style.backgroundColor = "red";
                        }
                        else {
                          event.target.style.backgroundColor = "white";
                        }
                        setAddlSerials((prevSerials) =>
                          prevSerials.map((prevSerial, i) => (i === index ? event.target.value : prevSerial))
                        );
                      }}
                      />
                      }
                    </div>
                  )
                })}
            </div>
            <div className="col-lg-6 col-md-12">
              <h6>Change Password</h6>
              <div className="form-group">
                <input className="form-control" placeholder="Current Password" type="password" value={password}
                  onChange={val => {
                    setPassword(val.target.value);
                  }} />
              </div>
              <div className="form-group">
                <input className="form-control" placeholder="New Password" type="password" value={newPassword}
                  onChange={val => {
                    setNewPassword(val.target.value);
                  }} />
              </div>
              <div className="form-group">
                <input className="form-control" placeholder="Confirm Password" type="password" value={confirmPassword}
                  onChange={val => {
                    setConfirmPassword(val.target.value);
                  }} />
              </div>
            </div>
          </div>
          <button className="btn btn-primary" type="button" id="btnUpdate"
            onClick={() => {
              console.log("update button pressed",addlSerials);
              saveAddlSerials();
            }}>
            Update
          </button>{" "}
          &nbsp;&nbsp;
          <button className="btn btn-success" type="button" id="btnAddNew"
          onClick={() => {
            console.log("adding deviceSerial, before count",addlSerials.length);
            if (addlSerials.length < 4) {
                setAddlSerials((prevSerials) => [...prevSerials, ""]);
             }
          }}>
            Add New Device
          </button>{" "}
          &nbsp;&nbsp;
          <button className="btn btn-default">Cancel</button>
        </div>
        </form>
      </div>
      </div>
      </div>
      </div>
    );
}
